module.exports = __webpack_public_path__ + "media/images/common-nav/national-forests/shawnee_national_forest-5c9a75c58c14e7ee658161bd5aee1247.jpg";